import { render, staticRenderFns } from "./BasicInformationBox.vue?vue&type=template&id=5615e9bc&"
import script from "./BasicInformationBox.vue?vue&type=script&lang=js&"
export * from "./BasicInformationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports